/** Where "Help & support" goes — the product's support inbox. */
export const SUPPORT_MAILTO = 'mailto:hello@teamlane.io';

export const DRAWER_WIDTH = 232;
export const DRAWER_WIDTH_COLLAPSED = 72;

/**
 * Phone breakpoint for the global bottom tab bar — at or below this width the
 * Shell shows `MobileBottomNav`. Matches the timesheet mobile break
 * (`timesheets/designTokens.MOBILE_MAX_WIDTH`) so the surfaces agree on "phone".
 */
export const MOBILE_NAV_MAX_WIDTH = 767;

/** Content height of the bottom tab bar (excludes the safe-area inset). Used to
 *  offset page-level fixed bars (e.g. the timesheet action bar) above it. */
export const MOBILE_TAB_BAR_HEIGHT = 56;
